// Use this for Local Development
// localStorage.setItem('tenant', 'eatiko');
export const WEBSITE_URL = "https://fleet.howincloud.com/api/v1/" + localStorage.getItem('tenant') + "/delivery";

// Comment out the above and Uncomment the below line before building the files for Production
// export const WEBSITE_URL = "https://" + window.location.hostname;